import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Link } from "react-router-dom";
import { Line } from "react-chartjs-2";
import {
  BodyAsFormData,
  noDataForGraph,
  exceldataFormate,
} from "../../../services/utilities/util";
import { JsonToExcel } from "react-json-to-excel";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import ChartExpandModal from "../../../services/utilities/ChartExpandModal";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class AssetVsMicromarketRent extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
    this.state = {
      mode: "quarter",
      modeText: "Switch To Yearly",
      noGraph: false,
      expandChartKey: Math.random(),
      expandChart: false,
      showLoader: false,
      showGraph: false,
      filters: "",
      tooltipClassname: null,
      tooltipArrow: faCaretUp,
      tooltipArrowDisplay: "none",
      tooltipYLabel: null,
      tooltipxLabel: null,
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
      xAxis: [],
      exceldata: [],
      showEllipsis:
        typeof this.props.showEllipsis != "undefined"
          ? this.props.showEllipsis
          : true,
      chartHeightClass:
        typeof this.props.chartHeightClass != "undefined"
          ? this.props.chartHeightClass
          : "col-lg-12",
    };
  }

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    if (this.state.showGraph && !this.state.noGraph) {
      const ctx = document
        .getElementById("rentalsVacancyLineChart")
        .getContext("2d");
      let gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, "rgba(113,206,250, 1)");
      gradient.addColorStop(1, "#cce9ff");
    }

    apiMiddleware
      .post(
        "api/edge/office/get_asset_vs_micromarket_rent",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ xAxis: res.data.x });
      });

    const superClass = this;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text:
              this.state.mode == "quarterly" || this.state.mode == "quarter"
                ? "Quarters"
                : "Years",
          },
          ticks: {
            callback: function (label, index, labels) {
              if (
                /\s/.test(superClass.state.xAxis) &&
                typeof superClass.state.xAxis[index] != "undefined"
              ) {
                return superClass.state.xAxis[index].split(" ");
              } else if (
                superClass.state.xAxis.length > 0 &&
                typeof superClass.state.xAxis[index] != "undefined"
              ) {
                return superClass.state.xAxis[index];
              } else {
                return "";
              }
            },
            autoSkip: false,
            color: "black",
            font: {
              size: 10,
            },
          },
        },
        y: {
          // ticks: {
          // display: false,
          // },
          beginAtZero: true,
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "₹ / sqft / month",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
          // text: 'Chart.js Bar Chart',
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
          external: function (context) {
            if (typeof context.tooltip.dataPoints != "undefined") {
              var className = "colorGreen";
              var arrowDir = faCaretUp;
              var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
              var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
              if (
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                ) <
                parseFloat(
                  context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                )
              ) {
                className = "colorRed";
                arrowDir = faCaretDown;
              }
              var PrecentDiff =
                parseFloat(
                  ((parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                  ) -
                    parseFloat(
                      context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                    )) *
                    100) /
                    parseFloat(
                      context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                    )
                ).toFixed(2) + "%";
              if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
                PrecentDiff = "";
              }
              superClass.setState({
                tooltipClassname: className,
                tooltipArrow: arrowDir,
                tooltipArrowDisplay: "",
                tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                tooltipxLabel: context.tooltip.dataPoints[0].label,
                tooltipYPercentDiff: PrecentDiff,
              });
            }
          },
        },
      },
    };

    apiMiddleware
      .post(
        "api/edge/office/get_asset_vs_micromarket_rent",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        // this.setState({ officeDemandSupply: res.data });
        let data = {
          labels: res.data.x,
          datasets: [
            {
              label: res.data.legend.y1,
              data: res.data.datapoints.y1.data,
              // fill: true,
              backgroundColor: res.data.bgcolor.y1,
              borderColor: res.data.bgcolor.y1,
              // lineTension: 0.4
            },
            {
              label: res.data.legend.y2,
              data: res.data.datapoints.y2.data,
              // fill: true,
              backgroundColor: res.data.bgcolor.y2,
              borderColor: res.data.bgcolor.y2,
              // lineTension: 0.4
            },
          ],
        };
        if (
          noDataForGraph(res.data.datapoints.y1.data) ||
          noDataForGraph(res.data.datapoints.y2.data)
        ) {
          superClass.setState({
            noGraph: false,
          });
        } else {
          superClass.setState({
            noGraph: true,
          });
        }

        superClass.setState({
          chartOtions: options,
          chartData: data,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });

      if (this.state.showGraph && !this.state.noGraph) {
        const ctx = document
          .getElementById("rentalsVacancyLineChart")
          .getContext("2d");
        let gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, "rgba(113,206,250, 1)");
        gradient.addColorStop(1, "#cce9ff");
      }

      const superClass = this;
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
            title: {
              display: true,
              text:
                this.state.mode == "quarterly" || this.state.mode == "quarter"
                  ? "Quarters"
                  : "Years",
            },
            ticks: {
              callback: function (label, index, labels) {
                if (
                  /\s/.test(superClass.state.xAxis) &&
                  typeof superClass.state.xAxis[index] != "undefined"
                ) {
                  return superClass.state.xAxis[index].split(" ");
                } else if (
                  superClass.state.xAxis.length > 0 &&
                  typeof superClass.state.xAxis[index] != "undefined"
                ) {
                  return superClass.state.xAxis[index];
                } else {
                  return "";
                }
              },
              autoSkip: false,
              color: "black",
              font: {
                size: 10,
              },
            },
          },
          y: {
            // ticks: {
            // display: false,
            // },
            beginAtZero: true,
            grid: {
              display: true,
              drawBorder: true,
            },
            title: {
              display: true,
              text: "₹ / sqft / month",
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            labels: {
              color: "rgb(0, 0, 0)",
              boxWidth: 6,
              boxHeight: 6,
              usePointStyle: true,
            },
          },
          title: {
            display: false,
            // text: 'Chart.js Bar Chart',
          },
          tooltip: {
            enabled: true,
            y: "bottom",
            backgroundColor: "#000",
            external: function (context) {
              if (typeof context.tooltip.dataPoints != "undefined") {
                var className = "colorGreen";
                var arrowDir = faCaretUp;
                var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
                var PrevDataIndex = CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
                if (
                  parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                  ) <
                  parseFloat(
                    context.tooltip.dataPoints[0].dataset.data[PrevDataIndex]
                  )
                ) {
                  className = "colorRed";
                  arrowDir = faCaretDown;
                }
                var PrecentDiff =
                  parseFloat(
                    ((parseFloat(
                      context.tooltip.dataPoints[0].dataset.data[CurrDataIndex]
                    ) -
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          PrevDataIndex
                        ]
                      )) *
                      100) /
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          PrevDataIndex
                        ]
                      )
                  ).toFixed(2) + "%";
                if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
                  PrecentDiff = "";
                }
                superClass.setState({
                  tooltipClassname: className,
                  tooltipArrow: arrowDir,
                  tooltipArrowDisplay: "",
                  tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                  tooltipxLabel: context.tooltip.dataPoints[0].label,
                  tooltipYPercentDiff: PrecentDiff,
                });
              }
            },
          },
        },
      };
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      body.append("mode", this.state.mode);
      apiMiddleware
        .post("api/edge/office/get_asset_vs_micromarket_rent", body)
        .then((res) => {
          this.setState({
            showLoader: false,
            showGraph: true,
            xAxis: res.data.x,
          });
          // this.setState({ officeDemandSupply: res.data });
          let data = {
            labels: res.data.x,
            datasets: [
              {
                label: res.data.legend.y1,
                data: res.data.datapoints.y1.data,
                // fill: true,
                backgroundColor: res.data.bgcolor.y1,
                borderColor: res.data.bgcolor.y1,
                // lineTension: 0.4
              },
              {
                label: res.data.legend.y2,
                data: res.data.datapoints.y2.data,
                // fill: true,
                backgroundColor: res.data.bgcolor.y2,
                borderColor: res.data.bgcolor.y2,
                // lineTension: 0.4
              },
            ],
          };
          if (
            noDataForGraph(res.data.datapoints.y1.data) ||
            noDataForGraph(res.data.datapoints.y2.data)
          ) {
            superClass.setState({
              noGraph: false,
            });
          } else {
            superClass.setState({
              noGraph: true,
            });
          }
          const excelData = exceldataFormate(res);

          superClass.setState({
            chartOtions: options,
            chartData: data,
            exceldata: excelData,
          });
        });
    }
  }

  downloadPdf() {
    const input = document.getElementById("assetMicromarketRent");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("assetMicromarketRent.pdf");
    });
  }

  getModeData() {
    if (this.state.mode == "years") {
      this.setState(
        { mode: "quarter", showLoader: true, showGraph: false },
        () => {
          const superClass = this;
          const options = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                grid: {
                  display: false,
                },
                title: {
                  display: true,
                  text:
                    this.state.mode == "quarterly" ||
                    this.state.mode == "quarter"
                      ? "Quarters"
                      : "Years",
                },
                ticks: {
                  callback: function (label, index, labels) {
                    if (
                      /\s/.test(superClass.state.xAxis) &&
                      typeof superClass.state.xAxis[index] != "undefined"
                    ) {
                      return superClass.state.xAxis[index].split(" ");
                    } else if (
                      superClass.state.xAxis.length > 0 &&
                      typeof superClass.state.xAxis[index] != "undefined"
                    ) {
                      return superClass.state.xAxis[index];
                    } else {
                      return "";
                    }
                  },
                  autoSkip: false,
                  color: "black",
                  font: {
                    size: 10,
                  },
                },
              },
              y: {
                // ticks: {
                // display: false,
                // },
                beginAtZero: true,
                grid: {
                  display: true,
                  drawBorder: true,
                },
                title: {
                  display: true,
                  text: "₹ / sqft / month",
                },
              },
            },
            plugins: {
              legend: {
                display: true,
                labels: {
                  color: "rgb(0, 0, 0)",
                  boxWidth: 6,
                  boxHeight: 6,
                  usePointStyle: true,
                },
              },
              title: {
                display: false,
                // text: 'Chart.js Bar Chart',
              },
              tooltip: {
                enabled: true,
                y: "bottom",
                backgroundColor: "#000",
                external: function (context) {
                  if (typeof context.tooltip.dataPoints != "undefined") {
                    var className = "colorGreen";
                    var arrowDir = faCaretUp;
                    var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
                    var PrevDataIndex =
                      CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
                    if (
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          CurrDataIndex
                        ]
                      ) <
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          PrevDataIndex
                        ]
                      )
                    ) {
                      className = "colorRed";
                      arrowDir = faCaretDown;
                    }
                    var PrecentDiff =
                      parseFloat(
                        ((parseFloat(
                          context.tooltip.dataPoints[0].dataset.data[
                            CurrDataIndex
                          ]
                        ) -
                          parseFloat(
                            context.tooltip.dataPoints[0].dataset.data[
                              PrevDataIndex
                            ]
                          )) *
                          100) /
                          parseFloat(
                            context.tooltip.dataPoints[0].dataset.data[
                              PrevDataIndex
                            ]
                          )
                      ).toFixed(2) + "%";
                    if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
                      PrecentDiff = "";
                    }
                    superClass.setState({
                      tooltipClassname: className,
                      tooltipArrow: arrowDir,
                      tooltipArrowDisplay: "",
                      tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                      tooltipxLabel: context.tooltip.dataPoints[0].label,
                      tooltipYPercentDiff: PrecentDiff,
                    });
                  }
                },
              },
            },
          };
          var body = new FormData();
          body.append("filter", JSON.stringify(this.props.filters));
          body.append("mode", this.state.mode);
          apiMiddleware
            .post("api/edge/office/get_asset_vs_micromarket_rent", body)
            .then((res) => {
              this.setState({
                showLoader: false,
                showGraph: true,
                xAxis: res.data.x,
              });
              // this.setState({ officeDemandSupply: res.data });
              let data = {
                labels: res.data.x,
                datasets: [
                  {
                    label: res.data.legend.y1,
                    data: res.data.datapoints.y1.data,
                    // fill: true,
                    backgroundColor: res.data.bgcolor.y1,
                    borderColor: res.data.bgcolor.y1,
                    // lineTension: 0.4
                  },
                  {
                    label: res.data.legend.y2,
                    data: res.data.datapoints.y2.data,
                    // fill: true,
                    backgroundColor: res.data.bgcolor.y2,
                    borderColor: res.data.bgcolor.y2,
                    // lineTension: 0.4
                  },
                ],
              };
              if (
                noDataForGraph(res.data.datapoints.y1.data) ||
                noDataForGraph(res.data.datapoints.y2.data)
              ) {
                superClass.setState({
                  noGraph: false,
                });
              } else {
                superClass.setState({
                  noGraph: true,
                });
              }
              const excelData = exceldataFormate(res);

              superClass.setState({
                chartOtions: options,
                chartData: data,
                exceldata: excelData,
              });
            });
        }
      );
    } else if (this.state.mode == "quarter") {
      this.setState(
        { mode: "years", showLoader: true, showGraph: false },
        () => {
          const superClass = this;
          const options = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                grid: {
                  display: false,
                },
                title: {
                  display: true,
                  text:
                    this.state.mode == "quarterly" ||
                    this.state.mode == "quarter"
                      ? "Quarters"
                      : "Years",
                },
                ticks: {
                  callback: function (label, index, labels) {
                    if (
                      /\s/.test(superClass.state.xAxis) &&
                      typeof superClass.state.xAxis[index] != "undefined"
                    ) {
                      return superClass.state.xAxis[index].split(" ");
                    } else if (
                      superClass.state.xAxis.length > 0 &&
                      typeof superClass.state.xAxis[index] != "undefined"
                    ) {
                      return superClass.state.xAxis[index];
                    } else {
                      return "";
                    }
                  },
                  autoSkip: false,
                  color: "black",
                  font: {
                    size: 10,
                  },
                },
              },
              y: {
                // ticks: {
                // display: false,
                // },
                beginAtZero: true,
                grid: {
                  display: true,
                  drawBorder: true,
                },
                title: {
                  display: true,
                  text: "₹ / sqft / month",
                },
              },
            },
            plugins: {
              legend: {
                display: true,
                labels: {
                  color: "rgb(0, 0, 0)",
                  boxWidth: 6,
                  boxHeight: 6,
                  usePointStyle: true,
                },
              },
              title: {
                display: false,
                // text: 'Chart.js Bar Chart',
              },
              tooltip: {
                enabled: true,
                y: "bottom",
                backgroundColor: "#000",
                external: function (context) {
                  if (typeof context.tooltip.dataPoints != "undefined") {
                    var className = "colorGreen";
                    var arrowDir = faCaretUp;
                    var CurrDataIndex = context.tooltip.dataPoints[0].dataIndex;
                    var PrevDataIndex =
                      CurrDataIndex == 0 ? 0 : CurrDataIndex - 1;
                    if (
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          CurrDataIndex
                        ]
                      ) <
                      parseFloat(
                        context.tooltip.dataPoints[0].dataset.data[
                          PrevDataIndex
                        ]
                      )
                    ) {
                      className = "colorRed";
                      arrowDir = faCaretDown;
                    }
                    var PrecentDiff =
                      parseFloat(
                        ((parseFloat(
                          context.tooltip.dataPoints[0].dataset.data[
                            CurrDataIndex
                          ]
                        ) -
                          parseFloat(
                            context.tooltip.dataPoints[0].dataset.data[
                              PrevDataIndex
                            ]
                          )) *
                          100) /
                          parseFloat(
                            context.tooltip.dataPoints[0].dataset.data[
                              PrevDataIndex
                            ]
                          )
                      ).toFixed(2) + "%";
                    if (PrecentDiff == "Infinity%" || PrecentDiff == "NaN%") {
                      PrecentDiff = "";
                    }
                    superClass.setState({
                      tooltipClassname: className,
                      tooltipArrow: arrowDir,
                      tooltipArrowDisplay: "",
                      tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                      tooltipxLabel: context.tooltip.dataPoints[0].label,
                      tooltipYPercentDiff: PrecentDiff,
                    });
                  }
                },
              },
            },
          };
          var body = new FormData();
          body.append("filter", JSON.stringify(this.props.filters));
          body.append("mode", this.state.mode);
          apiMiddleware
            .post("api/edge/office/get_asset_vs_micromarket_rent", body)
            .then((res) => {
              this.setState({
                showLoader: false,
                showGraph: true,
                xAxis: res.data.x,
              });
              // this.setState({ officeDemandSupply: res.data });
              let data = {
                labels: res.data.x,
                datasets: [
                  {
                    label: res.data.legend.y1,
                    data: res.data.datapoints.y1.data,
                    // fill: true,
                    backgroundColor: res.data.bgcolor.y1,
                    borderColor: res.data.bgcolor.y1,
                    // lineTension: 0.4
                  },
                  {
                    label: res.data.legend.y2,
                    data: res.data.datapoints.y2.data,
                    // fill: true,
                    backgroundColor: res.data.bgcolor.y2,
                    borderColor: res.data.bgcolor.y2,
                    // lineTension: 0.4
                  },
                ],
              };
              if (
                noDataForGraph(res.data.datapoints.y1.data) ||
                noDataForGraph(res.data.datapoints.y2.data)
              ) {
                superClass.setState({
                  noGraph: false,
                });
              } else {
                superClass.setState({
                  noGraph: true,
                });
              }
              const excelData = exceldataFormate(res);

              superClass.setState({
                chartOtions: options,
                chartData: data,
                exceldata: excelData,
              });
            });
        }
      );
    }

    if (this.state.modeText == "Switch To Quarterly") {
      this.setState({ modeText: "Switch To Yearly" });
    } else if (this.state.modeText == "Switch To Yearly") {
      this.setState({ modeText: "Switch To Quarterly" });
    }
  }

  render() {
    return (
      <div className="widget widgetGraph" id="assetMicromarketRent">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {!this.state.showLoader && this.state.noGraph && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/NoGraph-01.png" className="w100" />
            </div>
          </div>
        )}
        {this.state.showGraph && !this.state.noGraph && (
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
              <p>Asset vs Micromarket Rent</p>
              <h4 className={this.state.tooltipClassname}>
                <FontAwesomeIcon
                  icon={this.state.tooltipArrow}
                  style={{ display: this.state.tooltipArrowDisplay }}
                />
                {this.state.tooltipYPercentDiff}
              </h4>
              <p className="colorBlack pSmall">{this.state.tooltipxLabel}</p>
            </div>
            <div className="col-lg-3 text-end">
              {this.state.showEllipsis && (
                <p className="colorBlack downloads">
                  <FontAwesomeIcon icon={faEllipsisV} />
                  <ul className="downloadOptions">
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.downloadPdf();
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "pdf_download");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append(
                          "screen_sub_type",
                          "Asset vs Micromarket Rent"
                        );
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                    </li>

                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        let body = new FormData();
                        body.append("path", window.location.pathname);
                        body.append("action", "excel_export");
                        body.append("count", 1);
                        body.append(
                          "hash",
                          window.location.search.split("?").pop()
                        );
                        body.append(
                          "screen_sub_type",
                          "Asset vs Micromarket Rent"
                        );
                        apiMiddleware
                          .post(process.env.REACT_APP_USER_ACTIVITY, body)
                          .then((res) => {
                            console.log(res);
                          });
                      }}
                    >
                      <JsonToExcel
                        title="Download as Excel"
                        data={this.state.exceldata}
                        fileName="assetMicromarketRent"
                        btnClassName="graphExcelDownloadBtn"
                      />
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.setState({
                          expandChart: true,
                          expandChartKey: Math.random(),
                        });
                      }}
                    >
                      Expand Chart
                    </li>
                    <li
                      className="pdfDownload"
                      onClick={(e) => {
                        this.getModeData();
                      }}
                    >
                      {this.state.modeText}
                    </li>
                  </ul>
                </p>
              )}
            </div>
            <div
              className={this.state.chartHeightClass}
              style={{ height: "300px" }}
            >
              <Line
                id="rentalsVacancyLineChart"
                options={this.state.chartOtions}
                data={this.state.chartData}
              />
            </div>
          </div>
        )}
        <ChartExpandModal
          openModal={this.state.expandChart}
          chartName={AssetVsMicromarketRent}
          key={this.state.expandChartKey}
          filters={this.state.filters}
          chartHeightClass={"col-lg-12 allChartHeight"}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(AssetVsMicromarketRent);
